import { legacy_createStore as CreateStore } from "redux";
import { appReducer } from "../reducer/Reducer";
import appState from "../state/State";

export const appStore = CreateStore(appReducer, appState);
